// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2nZ42","ranges":"BmiRanges_ranges__1Q3c7"};